<template>
    <div class="lg:container mx-auto">
        <MyAccountLogin>
            <div class="grid grid-cols-1 lg:grid-cols-12 gap-2">
                <div class="lg:col-span-2 lg:border-r">
                    <MyAccountNavigation />
                </div>
                <div class="lg:col-span-10 p-2">
                    <div class="lg:flex justify-between items-center border-b">
                        <h1 class="font-bold text-base py-2">Ihre Bestellungen in der Übersicht</h1>
                        <div class="flex justify-end items-center gap-8">
                            <label class="text-sm" for="selectedMonth">Zeitraum</label>
                            <div><input id="selectedMonth" v-model="selectedMonth" class="inp sm" :max="currentYear + '-' + currentMonth" type="month"></div>
                        </div>
                    </div>
                    <div class="py-4">
                        <MyAccountOrderList :orders="orders" :date="getMonthName(selectedMonth)" />
                    </div>
                </div>
            </div>
        </MyAccountLogin>
    </div>
</template>
<script setup lang="ts">
    import type { Order } from '~/composables/shoppingCartApi';
    useHead({
        title: 'Bestellungen',
    });
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1 < 10 ? '0' + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
    const currentYear = currentDate.getFullYear();
    const selectedMonth = ref(`${currentYear}-${currentMonth}`);
    const orders = ref<Array<Order>>(await getOrdersForMonth(getTimeStamp()));
    
    onMounted(async () => {
        orders.value = await getOrdersForMonth(getTimeStamp());
    });

    watch(useCurrentUserState(), async () => {
        orders.value = await getOrdersForMonth(getTimeStamp());
    });

    watch(selectedMonth, async () => {
        orders.value = await getOrdersForMonth(getTimeStamp());
    });

    function getTimeStamp() {
        const [year, month] = selectedMonth.value.split('-');
        return new Date(parseInt(year), parseInt(month) - 1).getTime();
    }

    function getMonthName(dateString) {
        const [year, month] = dateString.split('-');
        const date = new Date(year, month - 1);
        const monthName = date.toLocaleDateString('de-DE', { month: 'long' });
        return `${monthName} ${year}`;
    }
</script>